module.exports = __webpack_public_path__ + "img/ico_d--black.15699a3a.svg";